import {
  Button,
  Form,
  TextInput,
  PasswordInput,
} from "carbon-components-react";
import {
  Credentials32,
  FaceDissatisfied32,
  Help32,
  ArrowRight24,
} from "@carbon/icons-react";
import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import http from "../../http-common";
import { toast } from "react-toastify";
import { AuthContext } from "../../contexts/AuthContext";
import CancelButton from "../../components/Buttons/CancelButton";
import { RuleCancelled24 } from "@carbon/icons-react";
import SubmitButton from "../../components/Buttons/SubmitButton";

const requiredMessage = "Campo obrigatório";

const loginSchema = yup.object({
  username: yup.string().required(requiredMessage),
  password: yup.string().required(requiredMessage),
});

const LoginPage = () => {
  const { authenticated, login } = useContext(AuthContext);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(loginSchema) });
  const navigate = useNavigate();

  const onSubmit = async (data) => {
    await login(data.username, data.password);
  };

  return (
    <div className="bx--row">
      <div className="bx--col-lg-8 content">
        <h4 className="pretitle emprega-green">
          O Emprega é para ti. Chegou a
        </h4>
        <h1 className="title">Competição de Planos de Negócio</h1>
        <h4>Que vai ajudar-te a dar asas ao teu sonho.</h4>
        <div className="bx--row mt-2">
          <div className="bx--col-lg-4">
            <h3>
              <Help32 /> Informa-te
            </h3>
            <p>
              Queres saber como funciona a Competição de Planos de Negócio
              (AgoraEmprega)? Descobre se és elegível e quais são os requisitos.
              Visita{" "}
              <a
                href="http://agoraemprega.seje.gov.mz/"
                rel="noreferrer"
                target="_blank"
              >
                www.agoraemprega.seje.gov.mz
              </a>
            </p>
          </div>
          <div className="bx--col-lg-4">
            <h3>
              <Credentials32 /> Regista-te
            </h3>
            <p>
              És jovem? Tens um negócio ou uma ideia de negócio que queres
              implementar? Então regista-te já!
            </p>
          </div>
          <div className="bx--col-lg-4">
            <h3>
              <FaceDissatisfied32 /> Expressa-te
            </h3>
            <p>
              Tens uma preocupação, reclamação, queixa, sugestão ou feedback,
              não fiques calado. Submeta já!
            </p>
          </div>
        </div>
      </div>
      <div className="bx--col-lg-4">
        <div className="card">
          <div className="card-header">
            <h3 className="card-title">Login</h3>
          </div>
          <div className="card-body">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <TextInput
                {...register("username")}
                id="username"
                labelText="Número de Telefone"
                placeholder=""
                maxLength={9}
              />
              <p className="field-error">{errors.username?.message}</p>
              <PasswordInput
                id="password"
                {...register("password")}
                labelText="Senha"
                placeholder=""
              />
              <p className="field-error">{errors.password?.message}</p>
              <Button
                type="submit"
                renderIcon={ArrowRight24}
                className="mt-2 btn-fluid"
              >
                Login
              </Button>
              {/* <p style={{ color: "#000" }} className="mt-1">
                  Ainda não tens conta?{" "}
                  <Link to={"../regista-te"}>Regista-te já</Link>
                </p> */}
              <p style={{ color: "#000", paddingTop: "10px" }}>
                <Link to={"/esqueceu-a-senha"}>Esqueceu a senha?</Link>
              </p>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
